import React from 'react';
import styled from 'styled-components/native';
import {
  WorkoutContainerHeaderTwo,
} from '../../../styles/common-styles.js';

function CoreFocus({img, title}) {

  //////console.log("CoreFocus render");

  return (
    <CoreFocusParent>

      <CoreFocusImage 
        source={{
          uri: img,
        }}
        resizeMode='contain'
      />
      <WorkoutContainerHeaderTwo>
        {title}
      </WorkoutContainerHeaderTwo>
    </CoreFocusParent>
  );
}

export const CoreFocusParent = styled.View`
  width:85px;
  min-height:100px;
  display:flex;
  justify-content:flex-start;
  align-items:center;
`;

export const CoreFocusImage = styled.Image`
  height:75px;
  width:75px;
  margin-bottom:5px;
`

export default CoreFocus;
